export default __webpack_public_path__ + "static/media/top_w576down_5.dd5c951b.png";